'use client';

// A message the person sent while Poneva worked, at the point in the answer
// where Poneva read it (`data-steer`, CONTRACT v1 §2). It reads as their own
// message, with one quiet line saying it was added mid-work, and the steps
// Poneva took after reading it follow on their own activity line.
import { CornerDownRightIcon } from 'lucide-react';
import type { FC } from 'react';
import { useNamespaceCopy } from '@/i18n/ns';
import steerCopy from '@/i18n/ns/steer';
import { ToolActivity } from './tool-activity';
import type { ThreadGroupPart } from './thread';

export const SteerRead: FC<{
  text: string;
  /** Tool part indices Poneva ran after reading it, up to the next message read mid-work. */
  after: readonly number[];
  /** Whether later steps belong to a further message read mid-work. */
  closed: boolean;
}> = ({ text, after, closed }) => {
  const copy = useNamespaceCopy(steerCopy);
  return (
    <>
      <div data-slot="steer-read" className="flex w-full flex-col items-end gap-1.5 py-1">
        <div
          dir="auto"
          className="bg-muted text-foreground max-w-[85%] rounded-2xl rounded-ee-md px-4 py-2.5 break-words whitespace-pre-wrap"
        >
          {text}
        </div>
        <span
          data-slot="steer-read-note"
          className="text-muted-foreground inline-flex items-center gap-1.5 px-1 text-xs"
        >
          <CornerDownRightIcon className="size-3" aria-hidden="true" />
          {copy.added}
        </span>
      </div>
      {after.length > 0 && (
        <ToolActivity
          group={{ indices: [...after] } as unknown as ThreadGroupPart}
          closed={closed}
        />
      )}
    </>
  );
};
